/**
 * shop-collection.js — FlorixSports Collection Page
 * Handles:
 *   1. Sort dropdown (toggle open/close + URL navigation)
 *   2. Filter bar toggle
 *   3. Size pill toggle + client-side product filtering
 *   4. Product count update
 *   5. Close sort dropdown on outside click
 */

(function () {
  'use strict';

  var SORT_MAP = {
    'created-descending': 'Newest',
    'price-ascending':    'Price: Low to High',
    'price-descending':   'Price: High to Low',
    'title-ascending':    'Name A–Z',
    'manual':             'Featured',
  };

  /* ══════════════════════════════════════════════
     SORT DROPDOWN
     ══════════════════════════════════════════════ */
  function initSort() {
    var sortBtn   = document.querySelector('.shop-coll__sort-btn');
    var sortPanel = document.querySelector('.shop-coll__sort-panel');
    if (!sortBtn || !sortPanel) return;

    /* Toggle open/close */
    sortBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = sortPanel.classList.toggle('is-open');
      sortBtn.classList.toggle('is-open', isOpen);
      sortBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    /* Option click → navigate with ?sort_by= */
    sortPanel.querySelectorAll('.shop-coll__sort-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var sortValue = opt.getAttribute('data-sort');
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortValue);
        window.location.href = url.toString();
      });
    });

    /* Close on outside click */
    document.addEventListener('click', function () {
      sortPanel.classList.remove('is-open');
      sortBtn.classList.remove('is-open');
      sortBtn.setAttribute('aria-expanded', 'false');
    });
  }

  /* ══════════════════════════════════════════════
     FILTER BAR TOGGLE
     ══════════════════════════════════════════════ */
  function initFilterToggle() {
    var filterBtn = document.querySelector('.shop-coll__filter-btn');
    var filterBar = document.querySelector('.shop-coll__filter-bar');
    if (!filterBtn || !filterBar) return;

    filterBtn.addEventListener('click', function () {
      var isOpen = filterBar.classList.toggle('is-open');
      filterBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  /* ══════════════════════════════════════════════
     SIZE PILLS + PRODUCT FILTERING
     ══════════════════════════════════════════════ */
  function initSizeFilter() {
    var pills      = document.querySelectorAll('.shop-coll__size-pill');
    var clearBtn   = document.querySelector('.shop-coll__filter-clear');
    var badge      = document.querySelector('.shop-coll__filter-badge');
    var countEl    = document.querySelector('.shop-coll__count');
    var products   = document.querySelectorAll('.shop-coll__product-wrap');
    var selected   = []; /* array of selected size strings */

    if (!pills.length) return;

    function updateFilter() {
      /* Update badge */
      if (badge) {
        badge.textContent = selected.length;
        badge.classList.toggle('is-visible', selected.length > 0);
      }

      /* Update clear button */
      if (clearBtn) {
        clearBtn.classList.toggle('is-visible', selected.length > 0);
      }

      /* Show/hide products */
      var visible = 0;
      products.forEach(function (wrap) {
        if (selected.length === 0) {
          wrap.classList.remove('is-hidden');
          visible++;
          return;
        }
        /* data-sizes="XS,S,M,L,XL" */
        var sizes = (wrap.getAttribute('data-sizes') || '').split(',').map(function (s) { return s.trim(); });
        var matches = selected.some(function (sel) { return sizes.indexOf(sel) !== -1; });
        wrap.classList.toggle('is-hidden', !matches);
        if (matches) visible++;
      });

      /* Update count */
      if (countEl) {
        countEl.textContent = visible + (visible === 1 ? ' product' : ' products');
      }
    }

    /* Pill toggle */
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var size = pill.getAttribute('data-size');
        var idx  = selected.indexOf(size);
        if (idx === -1) {
          selected.push(size);
          pill.classList.add('is-selected');
        } else {
          selected.splice(idx, 1);
          pill.classList.remove('is-selected');
        }
        updateFilter();
      });
    });

    /* Clear all */
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        selected = [];
        pills.forEach(function (p) { p.classList.remove('is-selected'); });
        updateFilter();
      });
    }
  }

  /* ══════════════════════════════════════════════
     INIT
     ══════════════════════════════════════════════ */
  function init() {
    initSort();
    initFilterToggle();
    initSizeFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
